// $(document).ready(function () {
  
//   function toggleStickyBar() {
//     let checkoutForm = $(".checkout-form1"); // Target checkout button
//     let stickyBar = $("#fixed-sticky-bar"); // Target sticky bar
//     let windowWidth = $(window).width(); // Get window width

//     if (checkoutForm.length && stickyBar.length) {
//       let checkoutTop =
//         checkoutForm.offset().top - (windowWidth >= 992 ? 100 : 50); // Offset based on screen size
//       let windowTop = $(window).scrollTop(); // Current scroll position

//       if (windowTop > checkoutTop) {
//         stickyBar.css("display", "block"); // Show sticky bar
//       } else {
//         stickyBar.css("display", "none"); // Hide sticky bar
//       }
//     }
//   }

//   $(window).on("scroll resize", toggleStickyBar); // Run on scroll & resize
//   toggleStickyBar(); // Run on page load

  

//   function updateSelectedOption(quantitySelect) {
//     let quantityValue = quantitySelect.val();

//     if (quantitySelect.length) {
//       quantitySelect.find("option").removeClass("selected"); // Remove previous class
//       quantitySelect
//         .find(`option[value="${quantityValue}"]`)
//         .addClass("selected"); // Add class
//     }

//       // if (quantitySelect.length) {
//       //   // Remove the "selected" attribute from the previously selected option
//       //   quantitySelect.find("option").removeAttr("selected");
      
//       //   // Find the option with the desired value and set the "selected" attribute
//       //   quantitySelect.find(`option[value="${quantityValue}"]`).attr("selected", "true"); // Set "selected" attribute
//       // }
//   }

//   // Run function on quantity change
//   $(document).on("change", ".content-for-layout .quantity .main-quantity", function () {
//       updateSelectedOption($(this));
//     }
//   );

//   // Initial update when page loads
//   $(".content-for-layout .quantity .main-quantity").each(function () {
//     updateSelectedOption($(this));
//   });

//   // Function to update the cart drawer quantity input
//   function updateCartQuantity(newQty) {
//     let cartQtyInput = $(
//       ".main-modal-popup-layout .main-modal-popup-content #cart-item-qty-input"
//     );

//     if (cartQtyInput.length) {
//       cartQtyInput.val(newQty).trigger("change").trigger("input"); // Update value and trigger event
//       console.log("Cart drawer quantity updated to:", newQty);
//     } else {
//       console.log("Cart drawer quantity input not found.");
//     }
//   }

//   // Handle add-to-cart button click
//   $(document).on("click", ".add-to-cart-btn", function (event) {
//     event.preventDefault();

//     let checkoutForm = $(".checkout-form1");

//     if (checkoutForm.length) {
//       checkoutForm.get(0).click(); // Perform native click
//       $("main-cart").load(window.location.href + " #cart-form");
//       console.log("checkout-form1 clicked!");

//       let selectedQty = $(".main-quantity select").val();
//       updateCartQuantity(selectedQty); // Ensure UI updates
//       // updateShopifyCart(selectedQty); // Sync with Shopify cart
//     } else {
//       console.log("checkout-form1 not found.");
//     }
//   });

//   $(document).on(
//     "click",
//     ".content-for-layout .sticky-add-to-cart .add-to-cart-btn",
//     function () {
//       setTimeout(() => {
//         let modalPopup = $(".main-modal-popup-layout");

//         if (!modalPopup.length) {
//           console.log("Modal not found.");
//           return;
//         }

//         console.log("Modal Found");

//         let qtyInput = modalPopup.find("input.main-cart-item-qty-input");
//         let priceContainer = modalPopup.find(".main-cart-item-total");

//         console.log("Quantity Input Found:", qtyInput.length > 0);
//         console.log("Price Container Found:", priceContainer.length > 0);

//         if (!qtyInput.length || !priceContainer.length) {
//           console.log("Required elements not found inside drawer.");
//           return;
//         }

//         let selectedValue = parseInt($(".main-quantity").val()) || 1; // Get selected quantity
//         let priceText =
//           priceContainer.text().trim() ||
//           priceContainer.contents().last().text().trim();
//         let pricePerItem =
//           parseFloat(priceText.replace(/[^\d.]/g, "")) /
//             parseInt(qtyInput.val()) || 0; // Extract per-item price

//         let newTotalPrice = pricePerItem * selectedValue;

//         console.log("in.............", newTotalPrice);

//         qtyInput.val(selectedValue).trigger("change").trigger("input");
//         priceContainer.text(`$${newTotalPrice.toFixed(2)}`);

//         console.log(
//           `Updated Quantity: ${selectedValue} , Updated Price: $${newTotalPrice.toFixed(
//             2
//           )}`
//         );
//       }, 1500); // Added delay to wait for modal
//     }
//   );

//   // Update price dynamically when quantity changes in the drawer
//   $(document).on("input", ".main-cart-item-qty-input", function () {
//     let qtyInput = $(this);
//     let newQty = parseInt(qtyInput.val()) || 1;
//     let priceContainer = qtyInput
//       .closest(".main-cart-item")
//       .find(".main-cart-item-total");

//     let priceText =
//       priceContainer.text().trim() ||
//       priceContainer.contents().last().text().trim();
//     let pricePerItem =
//       parseFloat(priceText.replace(/[^\d.]/g, "")) / newQty || 0;

//     let newTotalPrice = pricePerItem * newQty;

//     priceContainer.text(`$${newTotalPrice.toFixed(2)}`);

//     console.log(
//       `Drawer Updated - Quantity: ${newQty}, Price: $${newTotalPrice.toFixed(
//         2
//       )}`
//     );
//   });
// });



$(document).ready(function () {
function toggleStickyBar() {
  let checkoutForm = $(".checkout-form1"); // Target checkout button
  let stickyBar = $("#fixed-sticky-bar"); // Target sticky bar
  let windowWidth = $(window).width(); // Get window width

  if (checkoutForm.length && stickyBar.length) {
    if (windowWidth <= 991) {
      // For devices with width 991px or less, always show the sticky bar.
      stickyBar.css("display", "block");
    } else {
      // For desktop (width above 991px), show/hide based on scroll position.
      let checkoutTop = checkoutForm.offset().top - 100; // Use 100px offset on desktop
      let windowTop = $(window).scrollTop(); // Current scroll position

      if (windowTop > checkoutTop) {
        stickyBar.css("display", "block");
      } else {
        stickyBar.css("display", "none");
      }
    }
  }
}
  $(window).on("scroll resize", toggleStickyBar); // Run on scroll & resize
  toggleStickyBar(); // Run on page load

  function updateSelectedOption(quantitySelect) {
    let quantityValue = quantitySelect.val();

    if (quantitySelect.length) {
      quantitySelect.find("option").removeClass("selected"); // Remove previous class
      quantitySelect
        .find(`option[value="${quantityValue}"]`)
        .addClass("selected"); // Add class
    }
  }

  // Run function on quantity change
  $(document).on("change", ".content-for-layout .quantity .main-quantity", function () {
      updateSelectedOption($(this));
    }
  );

  // Initial update when page loads
  $(".content-for-layout .quantity .main-quantity").each(function () {
    updateSelectedOption($(this));
  });

  // Function to update the cart drawer quantity input
  function updateCartQuantity(newQty) {
    let cartQtyInput = $(
      ".main-modal-popup-layout .main-modal-popup-content #cart-item-qty-input"
    );

    if (cartQtyInput.length) {
      cartQtyInput.val(newQty).trigger("change").trigger("input"); // Update value and trigger event
      console.log("Cart drawer quantity updated to:", newQty);
    } else {
      console.log("Cart drawer quantity input not found.");
    }
  }

  // Handle add-to-cart button click
  $(document).on("click", ".add-to-cart-btn", function (event) {
    event.preventDefault();

    let checkoutForm = $(".checkout-form1");

    if (checkoutForm.length) {
      checkoutForm.get(0).click(); // Perform native click
      $("main-cart").load(window.location.href + " #cart-form");
      console.log("checkout-form1 clicked!");

      let selectedQty = $(".main-quantity select").val();
      updateCartQuantity(selectedQty); // Ensure UI updates
      // updateShopifyCart(selectedQty); // Sync with Shopify cart

    // $("#cart-icon-bubble").load(window.location.href + " #cart-icon-bubble", function () {
    //                   console.log("Bubble updated successfully");
    //                 }); 
    } else {
      console.log("checkout-form1 not found.");
    }
  });

  $(document).on(
    "click",
    ".content-for-layout .sticky-add-to-cart .add-to-cart-btn",
    function () {
      setTimeout(() => {
        let modalPopup = $(".main-modal-popup-layout");

        if (!modalPopup.length) {
          console.log("Modal not found.");
          return;
        }

        console.log("Modal Found");

        let qtyInput = modalPopup.find("input.main-cart-item-qty-input");
        let priceContainer = modalPopup.find(".main-cart-item-total");

        console.log("Quantity Input Found:", qtyInput.length > 0);
        console.log("Price Container Found:", priceContainer.length > 0);

        if (!qtyInput.length || !priceContainer.length) {
          console.log("Required elements not found inside drawer.");
          return;
        }

        let selectedValue = parseInt($(".main-quantity").val()) || 1; // Get selected quantity
        let priceText =
          priceContainer.text().trim() ||
          priceContainer.contents().last().text().trim();
        let pricePerItem =
          parseFloat(priceText.replace(/[^\d.]/g, "")) /
            parseInt(qtyInput.val()) || 0; // Extract per-item price

        let newTotalPrice = pricePerItem * selectedValue;

        console.log("in.............", newTotalPrice);

        qtyInput.val(selectedValue).trigger("change").trigger("input");
        priceContainer.text(`$${newTotalPrice.toFixed(2)}`);

        console.log(
          `Updated Quantity: ${selectedValue} , Updated Price: $${newTotalPrice.toFixed(
            2
          )}`
        );
      }, 1500); // Added delay to wait for modal
    }
  );

  // Update price dynamically when quantity changes in the drawer and subtotal price updated 

  $(document).on("input", ".main-cart-item-qty-input", function () {
    let qtyInput = $(this);
    let newQty = parseInt(qtyInput.val()) || 1;

    let itemContainer = qtyInput.closest(".main-cart-item");
    let priceContainer = itemContainer.find(".main-cart-item-total");
    let unitPriceContainer = itemContainer.find(".main-cart-item-price");

    //  Get the original price (per unit price)
    let unitPriceText = unitPriceContainer.text().trim() || unitPriceContainer.contents().last().text().trim();
    let unitPrice = parseFloat(unitPriceText.replace(/[^\d.]/g, "")) || 0;

    // Calculate new total price based on quantity
    let newTotalPrice = unitPrice * newQty;
    priceContainer.text(`$${newTotalPrice.toFixed(2)}`);

    console.log(`Drawer Updated - Quantity: ${newQty}, Price: $${newTotalPrice.toFixed(2)}`);

    // Update subtotal
    setTimeout(updateCartSubtotal, 200);
});

// Function to calculate & update subtotal
function updateCartSubtotal() {
    let subtotal = 0;

    $(".main-cart-item-total").each(function () {
        let itemText = $(this).text().trim();
        let itemTotal = parseFloat(itemText.replace(/[^\d.]/g, "")) || 0;

        subtotal += itemTotal;
    });

    $(".main-cart-checkout-subtotal-value").text(`$${subtotal.toFixed(2)}`);

    console.log(`Cart Subtotal Updated: $${subtotal.toFixed(2)}`);
}  
});



